module.exports = __webpack_public_path__ + "static/img/Button_Apple_Pay.308f335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Button_Apple_Pay.png
// module id = 7yhf
// module chunks = 1